$(window).on('load', function () {

    // promo slider at top of the page
    var numSlides = $('.promo-slider .agan-swiper .swiper-wrapper .swiper-slide').length;
    var bolLoop = (numSlides > 1);
    var sliderPagination = (numSlides > 1) ? '.swiper-pagination' : true;
    var promoSlider = new Swiper('.promo-slider .swiper-container', {
        direction: 'horizontal',
        loop: bolLoop,
        speed: 500,
        observer: true,
        observeParents: true,
        spaceBetween: 30,
        centeredSlides: true,
        breakpoints: {
            768: {
                nextEl: null,
                prevEl: null
            }
        },
        pagination: {
            el: sliderPagination,
            clickable: true,
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });

    function Dyagan_compareFlyout() {
        var self = this;
        var template = "<div id='flyoutcompare' class='flyout flyout-ignore-scroll flyout-autoclose flyout-service'><div class='lead flyout-header'>" + $('.articleCompareNote').val() + "</div><div style='color: #15aff6'>" + $('.articleCompareNotice').val() + "</div></div>";

        //Sind mindestens 2 Artikel im Vergleich, dann Weiterleitung..., wenn nicht, dann Hinweisbanner auspielen
        self.hasEnoughItems = function () {
            if ($('.agan-badge--compare').text() < 2) {
                return false;
            }
            return true;
        };

        //Hinweisbanner mit ausgelagertem Inhalt
        self.appendAttentionBanner = function () {
            $('.small-menu-item--compare').append(template);
        };

        self.init = function () {
            self.appendAttentionBanner();

            var flyoutcomp = $('#flyoutcompare');

            $('.small-menu-item--compare').click(function (event) {
                if (self.hasEnoughItems()) {
                    return;
                }

                if (!flyoutcomp.hasClass('active')) {
                    flyoutcomp.show();
                    flyoutcomp.addClass('active');
                } else {
                    flyoutcomp.hide();
                    flyoutcomp.removeClass('active');
                }
                event.preventDefault();

                return;
            });

            // Hide on body click
            $(document).mouseup(function (e) {
                var target = $(e.target);
                if (target.closest('.small-menu-item--compare').length == 0 && !target.hasClass('small-menu-item--compare')) {
                    flyoutcomp.hide();
                    flyoutcomp.removeClass('active');
                }
            });
        };
        self.init();
    }

    new Dyagan_compareFlyout();
});
